export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14026.349db8f5.jpg";